<script>

</script>
<div class="screen-orientation"></div>

<style>
.screen-orientation {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('../images/screen-orientation.png') #009EDF center center;
  background-size: contain;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;

  z-index: 10;
}
</style>
